import clsx from 'clsx'
import includes from 'lodash/includes'
import React, { FC, useContext } from 'react'

import { RTEContent } from '@Components/RTEContent'
import { Block } from '@Generated/graphql'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'
import { MetadataContext } from '@Globals/Metadata'

import styles from './TextBlock.module.scss'

interface TextBlockProps {
  id?: string
  textBlock: Block
}
const TextBlock: FC<TextBlockProps> = ({ id, textBlock }) => {
  const text = getRTEFieldText(textBlock.fields || [], 'text')
  const { page } = useContext(MetadataContext)

  if (!text) {
    return null
  }

  return (
    <div
      className={clsx(
        styles.textContainer,
        includes(['frontpages', 'category', 'filters'], page?.type) && styles.fullWidth,
      )}
      id={id}
    >
      <RTEContent html={text} />
    </div>
  )
}

export default TextBlock
